import { Text } from 'platform-components';
import React from 'react';

import './course-container-banner__info.scss';

interface Props {
    slug: string;
}

export const CourseContainerBannerInfo = ({ slug }: Props) => {
    return (
        <div className="course-container-banner__info">
            <div className="course-container-banner__info-item">
                <div className="course-container-banner__info-item-label">
                    <Text id="library.collection.duration" size={Text.SIZE.S} />
                </div>
                <Text id={`library.collection.${slug}.duration`} size={Text.SIZE.XL} />
            </div>
            <div className="course-container-banner__info-item">
                <div className="course-container-banner__info-item-label">
                    <Text id="library.collection.intensity" size={Text.SIZE.S} />
                </div>
                <Text id={`library.collection.${slug}.intensity`} size={Text.SIZE.XL} />
            </div>
            <div className="course-container-banner__info-item">
                <div className="course-container-banner__info-item-label">
                    <Text id="library.collection.content" size={Text.SIZE.S} />
                </div>
                <Text id={`library.collection.${slug}.content`} size={Text.SIZE.XL} />
            </div>
        </div>
    );
};
